<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolDeliverListResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :ignoreMaxTableItemLimit="true" :importEnabled="true"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :useCustomFieldsDefaultFlag="false"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-overlay :show="onBreaking" spinner-variant="primary" spinner-type="grow"
                                               spinner-small class="ml-auto">
                                        <b-button
                                            :disabled="$store.state['sithMesStoolDeliverList'].checkedItems.length != 1"
                                            variant="outline-primary"
                                            size="sm"
                                            @click="dialogBreakVisible = true">分解清单
                                        </b-button>
                                    </b-overlay>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolDeliverList'].checkedItems.length != 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDetailVisible = true">导入明细
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="viewDetail">查看明细
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolDeliverList'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDeliverTaskVisible = true">生成发货任务
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolDeliverList'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="printLabel">打印物料码
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="填写分解个数" :visible.sync="dialogBreakVisible">
            <el-form>
                <el-input-number v-model="breakNum" :min="1" label="分解个数"></el-input-number>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogBreakVisible = false">取 消</el-button>
                <el-button type="primary" @click="breakList()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入明细" :visible.sync="dialogDetailVisible">
            <el-form :inline="true" :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px">
                <el-form-item
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    :key="index">
                    <el-input class="detailInput" v-model="domain.material" placeholder="请输入物料号"></el-input>
                    <el-input class="detailInput" v-model="domain.materialDesc" placeholder="请输入物料描述"></el-input>
                    <el-input class="detailInput" v-model="domain.quantity" placeholder="请输入数量"></el-input>
                    <el-button @click="removeDomain(domain)">删除</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addDomain">新增明细</el-button>
                    <el-button type="primary" @click="submitForm()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="任务详情" :visible.sync="dialogDeliverTaskVisible">
            <el-form :inline=true :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item class="taskInput" label="发货方" prop="consignor">
                    <el-input v-model="ruleForm.consignor" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="发货联系方式" prop="consignorContact">
                    <el-input v-model="ruleForm.consignorContact" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="收货方" prop="consignee">
                    <el-input v-model="ruleForm.consignee" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="收货联系方式" prop="consigneeContact">
                    <el-input v-model="ruleForm.consigneeContact" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="货物描述" prop="goodsDescription">
                    <el-input v-model="ruleForm.goodsDescription" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="交货地点" prop="goodsDescription">
                    <el-input v-model="ruleForm.deliverLocation" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="taskInput" label="件数" prop="count" required>
                    <el-input-number v-model="ruleForm.count" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="长度/m" prop="length" required>
                    <el-input-number v-model="ruleForm.length" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="宽度/m" prop="width" required>
                    <el-input-number v-model="ruleForm.width" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="高度/m" prop="height" required>
                    <el-input-number v-model="ruleForm.height" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="体积/m³" prop="volume">
                    <el-input-number v-model="calculatedVolume" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="净重/KG" prop="weight" required>
                    <el-input-number v-model="ruleForm.weight" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item class="taskInput" label="毛重/KG" prop="grossWeight" required>
                    <el-input-number v-model="ruleForm.grossWeight" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeliverTaskVisible = false">取 消</el-button>
                <el-button type="primary" @click="generateTask()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-08-24 11:54:23

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import moment from 'moment';

export default {
    name: "sithMesStoolDeliverListListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, commonViewsUtil],
    data() {
        return {
            breakNum: 2,
            onBreaking: false,
            dialogBreakVisible: false,
            dialogDetailVisible: false,
            dialogDeliverTaskVisible: false,
            ruleForm: {
                consignor: '',
                consignee: '西门子能源工业透平机械（葫芦岛）有限公司',
                consigneeContact: '',
                consignorContact: '',
                goodsDescription: '',
                deliverLocation: '辽宁省葫芦岛市高新技术产业开发区，高新7路3号',
                count: '',
                length: '',
                width: '',
                height: '',
                volume: '',
                weight: '',
                grossWeight: ''
            },
            rules: {
                consignor: [
                    {required: true, message: '请输入发货人', trigger: 'blur'},
                ],
                consignee: [
                    {required: true, message: '请输入收货人', trigger: 'blur'},
                ],
                consignorContact: [
                    {required: true, message: '请输入发货联系人', trigger: 'blur'},
                ],
                consigneeContact: [
                    {required: true, message: '请输入收货联系人', trigger: 'blur'},
                ],
                goodsDescription: [
                    {required: true, message: '请输入货物描述', trigger: 'blur'},
                ],
                deliverLocation: [
                    {required: true, message: '请输入交货地点', trigger: 'blur'},
                ]
            },
            dynamicValidateForm: {
                domains: [
                    {
                        material: '',
                        materialDesc: '',
                        quantity: ''
                    },
                ],
            }
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        calculatedVolume: {
            get() {
                const {length, width, height} = this.ruleForm
                if (length && width && height) {
                    return (length * width * height).toFixed(2)
                } else {
                    return ''
                }
            },
            set(newValue) {
                this.ruleForm.volume = newValue
            }
        }
    },
    created() {
        const lastConsignor = localStorage.getItem('lastConsignor');
        if (lastConsignor) {
            this.ruleForm.consignor = lastConsignor
        }
        const lastConsignorContact = localStorage.getItem('lastConsignorContact');
        if (lastConsignor) {
            this.ruleForm.consignorContact = lastConsignorContact;
        }
        const lastConsignee = localStorage.getItem('lastConsignee');
        if (lastConsignor) {
            this.ruleForm.consignee = lastConsignee;
        }
        const lastConsigneeContact = localStorage.getItem('lastConsigneeContact');
        if (lastConsignor) {
            this.ruleForm.consigneeContact = lastConsigneeContact;
        }
    },
    methods: {
        breakList() {
            this.dialogBreakVisible = false;
            this.onBreaking = true
            let row = this.$store.state[this.modelName].entity;
            let url = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverList/breakList/" + this.breakNum;
            this.$_emApiMixin_post(url, row).then(response => {
                if (response.status === 200 && response.data.length === this.breakNum) {
                    this.$message.success("分解清单成功!");
                    this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.poNumberFilter = row.poNumber;
                    this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.itemNumberFilter = row.itemNumber;
                    this.$refs["emListFilter"].doQuery();
                } else {
                    this.$message.error("分解清单失败!");
                }
            }).finally(() => this.onBreaking = false);
        },
        generateTask() {

            this.dialogDeliverTaskVisible = false;
            let form = this.ruleForm;
            if (!form.consignor || !form.consignorContact || !form.consignee || !form.consigneeContact
                || !form.goodsDescription || !form.deliverLocation || !form.count || !form.length || !form.width || !form.height || !form.grossWeight || !form.volume || !form.weight) {
                commonViewsUtil.showWarning(this, "请输入必填项！");
                return;
            }

            let entityModel = this.$store.state[this.modelName];
            const items = entityModel.rows.filter(row => entityModel.checkedItems.indexOf(row.id) !== -1);
            let arr = items.map(row => {
                return {
                    id: row.id,
                };
            });

            let task = {};
            task.goodsDescription = form.goodsDescription;
            task.deliverLocation = form.deliverLocation;
            task.count = form.count;
            task.length = form.length;
            task.width = form.width;
            task.height = form.height;
            task.volume = form.volume;
            task.weight = form.weight;
            task.grossWeight = form.grossWeight;
            task.consignor = form.consignor;
            task.consignorContact = form.consignorContact;
            task.consignee = form.consignee;
            task.consigneeContact = form.consigneeContact;
            task.consignStatus = '待确认发货'
            task.deliverTime = moment().format('YYYY-MM-DD HH:mm:ss');

            let deliverGenerateForm = {};
            deliverGenerateForm.task = task;
            deliverGenerateForm.deliverList = arr;
            let deliverUrl = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverList/generateTask";
            this.$_emApiMixin_post(deliverUrl, deliverGenerateForm).then(response => {

                commonViewsUtil.showSuccess(this, "生成成功！");

                this.$router.push({name: 'sithMesStoolDeliverTaskList'});

            });


        },
        removeDomain(item) {
            var index = this.dynamicValidateForm.domains.indexOf(item)
            if (index !== -1) {
                this.dynamicValidateForm.domains.splice(index, 1)
            }
        },
        addDomain() {
            this.dynamicValidateForm.domains.push({
                value: '',
                key: Date.now()
            });
        },
        printLabel() {
            let url = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + `/sithMesStoolDeliverList/getDeliverPrintList?ids=${this.$store.state[this.modelName]["checkedItems"].join(",")}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.$router.push({
                        name: "sithMesInventoryItemPrint",
                        query: response.data,
                    });
                })
        },
        submitForm() {

            this.dialogDetailVisible = false;

            let row = this.$store.state[this.modelName].entity;
            let deliverList = this.dynamicValidateForm.domains;
            let url = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverList/saveDetailList";
            deliverList.forEach(list => {
                list.taskCode = row.taskCode;
                list.poNumber = row.poNumber;
                list.itemNumber = row.itemNumber;
                list.itemNumber = row.itemNumber;
                list.type = 'detail';
            });
            this.$_emApiMixin_post(url, deliverList).then(response => {
                commonViewsUtil.showSuccess(this, "添加完成！");
            });
        },
        viewDetail() {
            this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.typeFilter = 'detail';
            this.$refs["emListFilter"].doQuery();
        }

    },
    mounted() {
        //客户说供应商想要默认这个界面进来就是未发货的，看着明显舒服点
        this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.generatedTaskFilter = false;
        this.$refs["emListFilter"].doQuery();
    },
    watch: {
        'ruleForm.consignor': {
            handler: (newVal) => {
                localStorage.setItem('lastConsignor', newVal)
            }
        },
        'ruleForm.consignorContact': {
            handler: (newVal) => {
                localStorage.setItem('lastConsignorContact', newVal)
            }
        },
        'ruleForm.consignee': {
            handler: (newVal) => {
                localStorage.setItem('lastConsignee', newVal)
            }
        },
        'ruleForm.consigneeContact': {
            handler: (newVal) => {
                localStorage.setItem('lastConsigneeContact', newVal)
            }
        }
    }
};
</script>

<style>
.taskInput {
    width: 320px !important;
}

.detailInput {
    width: 200px !important;
}
</style>
